import React from 'react';
import { ChevronDown } from 'lucide-react';
import { MarketplaceBrandMark } from './EventMarketplaceDeepLinks';
import styles from './ListedVlRowControls.module.css';

type Props = {
  enabledMarketplaceIds: string[];
  onEditMarketplaces: (e: React.MouseEvent) => void;
  disabled?: boolean;
  /** Max marketplace chips shown before "+N". */
  maxChips?: number;
  className?: string;
};

/** Listed-tab Marketplace column: click to edit which marketplaces are active. */
export function ListedVlRowControls({
  enabledMarketplaceIds,
  onEditMarketplaces,
  disabled = false,
  maxChips = 3,
  className,
}: Props) {
  const visible = enabledMarketplaceIds.slice(0, maxChips);
  const overflow = Math.max(0, enabledMarketplaceIds.length - visible.length);

  return (
    <span
      className={[styles.listedVlControls, className].filter(Boolean).join(' ')}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className={styles.marketplaceBtn}
        disabled={disabled}
        title="Edit marketplace selection"
        aria-label="Edit marketplace selection"
        onClick={onEditMarketplaces}
      >
        {visible.map((id) => (
          <span key={id} className={styles.marketplaceLogoChip}>
            <MarketplaceBrandMark id={id} size={16} />
          </span>
        ))}
        {overflow > 0 && (
          <span className={`${styles.marketplaceChip} ${styles.chipDefault}`}>+{overflow}</span>
        )}
        <ChevronDown size={10} className={styles.chevron} aria-hidden="true" />
      </button>
    </span>
  );
}
